import { render } from "./FormKitCKEditor.vue?vue&type=template&id=578143c6"
import script from "./FormKitCKEditor.vue?vue&type=script&lang=js"
export * from "./FormKitCKEditor.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__